// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Type_Page from "../../type/Type_Page.bs.js";
import * as Layout_Rc_Presse from "../layout/presse/Layout_Rc_Presse.bs.js";

function Page_Rc_Presse(Props) {
  var page = Props.page;
  var match = Context.I18n.getState(undefined);
  var formaters = match.formaters;
  var match$1 = Context.Config.getState(undefined);
  var layout = Type_Page.Presse.makeFromPresse(match.labels, page, formaters.availabilityDate, formaters.betweenDates, formaters.nextBroadcastDate, match$1.serverTime, /* Rc */1);
  return React.createElement(Layout_Rc_Presse.make, {
              layout: layout
            });
}

var make = Page_Rc_Presse;

export {
  make ,
}
/* react Not a pure module */
